export default __webpack_public_path__ + "static/media/5.42cb6f04.png";